/**
 * @generated SignedSource<<8c1e9933c074f498babae4665337daf0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteJobInput = {
  jobId: any;
};
export type DeleteJobMutation$variables = {
  input: DeleteJobInput;
};
export type DeleteJobMutation$data = {
  readonly deleteJob: {
    readonly success: boolean;
  };
};
export type DeleteJobMutation = {
  response: DeleteJobMutation$data;
  variables: DeleteJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteJobPayload",
    "kind": "LinkedField",
    "name": "deleteJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteJobMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteJobMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fabd7b175ffc15087186fb95aac5a322",
    "id": null,
    "metadata": {},
    "name": "DeleteJobMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteJobMutation(\n  $input: DeleteJobInput!\n) {\n  deleteJob(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c6d5899a7f096ed956fb1a2226f23ed";

export default node;
